// extracted by mini-css-extract-plugin
export default {"colorStyle":"add-process-parameter-modal_colorStyle__U5zih"};